import {useEffect, useRef, useState} from 'react'
import * as bootstrap from 'bootstrap'
import {AxiosError} from 'axios'
import {useSelectDeviceId, useSelectInputSectionValue} from '../../../_metronic/layout/core'
import {awsHomePublishData, awsHomeSubscribeStringData} from '../../modules/auth/core/_requests'
import {KTIcon} from '../../../_metronic/helpers'

function ImageStream({item, index1, index2, title, deviceCode, experimentId, circuitId}: any) {
  const localSelectDevice = window.localStorage.getItem('selectDevice')
  const localSelectDevices = localSelectDevice ? JSON.parse(localSelectDevice) : null
  const {SelectInputSectionValue, setSelectInputSectionValue} = useSelectInputSectionValue()
  const {SelectDeviceId} = useSelectDeviceId()
  // const [str, setStr] = useState(JSON.stringify(SelectInputSectionValue) || '')
  const otherButtonRef = useRef(null)

  const sendAwsData = async (newValue: any) => {
    try {
      if (SelectDeviceId.length > 0) {
        const requests = SelectDeviceId.map(async (id) => {
          try {
            const {data} = await awsHomeSubscribeStringData(experimentId, circuitId, id, {
              device: deviceCode,
              degerlers: newValue,
            })
            setImageData(data)
            return data
          } catch (err) {
            // İstek sırasında bir hata olursa, hata nesnesini diziye ekliyoruz
            return Promise.reject(err)
          }
        })

        // Tüm istekler tamamlandığında çalışacak kod
        const results = await Promise.all(requests)
        //  console.log(results) // Tüm sonuçları görebilirsiniz
      } else {
        console.error('SelectDeviceId boş!')
      }
    } catch (err) {
      const error = `${(err as AxiosError)?.response?.data}`
      console.error(error)
    }
  }

  const sendAwsDataControl = async (numArr: any) => {
    try {
      if (SelectDeviceId.length > 0) {
        const requests = SelectDeviceId.map(async (id) => {
          try {
            const response = await awsHomePublishData(id, experimentId, circuitId, {
              device: deviceCode,
              degerlers: numArr,
            })
            return response.data
          } catch (err) {
            return Promise.reject(err)
          }
        })
        // Tüm istekler tamamlandığında çalışacak kod
        const results = await Promise.all(requests)
        //  console.log(results) // Tüm sonuçları görebilirsiniz
      } else {
        console.error('SelectDeviceId boş!')
      }
    } catch (err) {
      const error = `${(err as AxiosError)?.response?.data}`
      console.error(error)
    }
  }

  function handleSetList(value: any) {
    const newData = SelectInputSectionValue // controlList'in kopyasını oluşturuyoruz
    if (newData && newData[index1] && newData[index1][index2]) {
      newData[index1][index2] = value
    } else {
      console.error('Geçersiz indeksler!')
    }
    return newData
  }

  const calculateArrayValue = (value: any) => {
    // const value = e.target.value
    const regex = /\[(.*?)\]/g
    const result: any = []

    let match: any
    while ((match = regex.exec(value))) {
      let strx = match[1]
      let data = strx.split(',').map(Number)
      result.push(data)
    }
    return result
  }

  const handleReadChange = (e: any) => {
    const newValue = calculateArrayValue(e)
    //  setStr(JSON.stringify(newValue))
    sendAwsData(newValue)
    //🏴󠁡󠁦󠁬󠁯󠁧󠁿 Log 👇
    //console.log(newValue)
    //
  }

  type NestedArray = (number | NestedArray)[]

  function flattenNestedArray(arr: NestedArray): number[] {
    const result: number[] = []

    if (arr.length > 0) {
      arr.forEach((item1: any) => {
        if (Array.isArray(item1) && item1.length > 0) {
          item1.forEach((item2) => {
            if (Array.isArray(item2) && item2.length > 0) {
              item2.forEach((value) => {
                result.push(value)
              })
            }
          })
        }
      })
    }
    return result
  }

  const handleRadioButtonChange = (e: any) => {
    const newValue = calculateArrayValue(e)
    let newList = handleSetList(newValue)
    let sendValue = flattenNestedArray(newList)
    setSelectInputSectionValue(newList)
    // setStr(JSON.stringify(newValue))
    sendAwsDataControl(sendValue)
    //🏴󠁡󠁦󠁬󠁯󠁧󠁿 Log 👇
    //console.log(newValue)
    //
  }

  const offhandleRadioButtonChange = (e: any) => {
    const newValue = calculateArrayValue(e)
    let newList = handleSetList(newValue)
    let sendValue = flattenNestedArray(newList)
    setSelectInputSectionValue(newList)
    // setStr(JSON.stringify(newValue))
    sendAwsDataControl(sendValue)
  }

  const [valuetToSend, setValueToSend] = useState(null)
  const [valuetToSendControl, setValueToSendControl] = useState(false)
  const [ImageData, setImageData] = useState(null)

  // 👇 Modal  Kapanış Kontrolü
  useEffect(() => {
    if (ImageData) {
      const modalElement: any = document.getElementById('imageStream_modal')

      modalElement.addEventListener('hidden.bs.modal', () => {
        setValueToSendControl(false)
        setValueToSend(null)
        offhandleRadioButtonChange(item.filter((i: any) => i.key === 'Turn Off')[0].value)
      })
    }
  }, [])

  useEffect(() => {
    if (valuetToSendControl) {
      const intervalId = setInterval(() => {
        handleReadChange(valuetToSend)
      }, 500)
      return () => clearInterval(intervalId)
    }
  }, [valuetToSendControl])

  const RadioItem = item.map((i: any, index: number) => (
    <div
      //  className='d-flex align-items-center form-check form-check-danger form-check-solid me-5'
      className=' d-flex form-check orm-check-danger form-check-solid me-5 col-12 my-4'
      key={i.id}
    >
      {/*}
      <input
        className='form-check-input  h-30px w-30px me-2'
        type='radio'
        name={`flexRadioDefault`}
        id={`flexRadio${item.id}`}
        value={item.value}
        disabled={SelectDeviceId ? (SelectDeviceId.length > 0 ? false : true) : true}
        checked={str.substring(1, str.length - 1) === item.value}
        onChange={(e: any) => {
          //if (item.value.charAt(item.value.length - 2) === '1') {
          if (item.value.charAt(5) === '1') {
            setValueToSend(e)
            setValueToSendControl(true)
            handleRadioButtonChange(e)
            const modal = bootstrap.Modal.getOrCreateInstance('#imageStream_modal')
            modal.show()
          } else {
            setValueToSendControl(false)
            setValueToSend(null)
            offhandleRadioButtonChange(e)
            const modal = bootstrap.Modal.getOrCreateInstance('#imageStream_modal')
            modal.hide()
          }
        }}
      />

      <label className='form-check-label fw-bold' htmlFor={`flexRadio${item.id}`}>
        {item.key}
      </label>
      {*/}

      <button
        ref={index === 0 ? otherButtonRef : null}
        type='button'
        className='btn btn-secondary btn-block'
        id={`streamButton${index}`}
        disabled={SelectDeviceId ? (SelectDeviceId.length > 0 ? false : true) : true}
        onClick={(e: any) => {
          if (i.value.charAt(5) === '1') {
            setValueToSend(i.value)
            setValueToSendControl(true)
            handleRadioButtonChange(i.value)
            const modal = bootstrap.Modal.getOrCreateInstance('#imageStream_modal')
            modal.show()
          } else {
            setValueToSendControl(false)
            setValueToSend(null)
            offhandleRadioButtonChange(i.value)
          }
        }}
      >
        {i.key}
      </button>
    </div>
  ))

  return (
    <>
      <div
        className='col-xl-3 col-12 sal-animate'
        data-sal-delay='200'
        data-sal='slide-up'
        data-sal-duration='500'
      >
        <div className='card card-flush h-100' style={{backgroundColor: '#FFE896'}}>
          <div className='card-header pt-5'>
            <h3 className='card-title text-gray-800 fw-bolder'>{title}</h3>
          </div>
          <div className='card-body pt-0'>
            <div className='d-flex mt-3 justify-content-between p-5 rounded bg-body row'>
              {RadioItem}
            </div>
          </div>
        </div>
      </div>

      {/*valuetToSendControl && ImageData && (
        <div className='card card-flush bg-yellow w-50'>
          <div className='card-header pt-5'>
            <h3 className='card-title text-gray-800 fw-bolder'>Stream</h3>
          </div>
          <div className='card-body pt-0'>
            <div className='card card-bordered p-4 '>
              <img
                style={{
                  width: '100%',
                  // height: '200px',
                }}
                className={`rounded`}
                src={`data:image/jpeg;base64,${ImageData}`}
              />
            </div>
          </div>
        </div>
              )*/}
      <ImageStreamModal ImageData2={ImageData} otherButtonRef={otherButtonRef} />
    </>
  )
}

export default ImageStream

function ImageStreamModal({ImageData2, otherButtonRef}: any) {
  return (
    <div className='modal fade' tabIndex={-1} id='imageStream_modal'>
      <div className='modal-dialog modal-dialog-centered modal-xl'>
        <div className='modal-content shadow-none'>
          <div className='modal-header'>
            <h3 className='modal-title'>Stream</h3>
            <div
              className='btn btn-icon btn-sm btn-active-light-primary ms-2'
              data-bs-dismiss='modal'
              aria-label='Close'
              onClick={() => {
                otherButtonRef.current.click()
              }}
            >
              <KTIcon iconName='cross' className='fs-2qx' />
            </div>
          </div>
          <div className='modal-body'>
            <div className={`card card-flush h-100`}>
              <img
                style={{
                  width: '100%',
                  height: '600px',
                }}
                className={`rounded`}
                src={`data:image/jpeg;base64,${ImageData2}`}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
